
<section>
    <cdk-virtual-scroll-viewport itemSize="50" orientation="horizontal" class="example-viewport" (scrolledIndexChange)="scrollHandler($event)">
        <div *cdkVirtualFor="let item of ds" class="example-item">{{item || 'Loading...'}}</div>
    </cdk-virtual-scroll-viewport>
</section>

<mat-divider></mat-divider>

<section>
    <p>Have some data? ({{!!someLocalData}}):</p>
    <!-- <kbd class="break-words">
        {{someLocalData | json }}
    </kbd> -->
</section>
<button type="button" (click)="throwTestError()">Test Sentry Error</button>

<router-outlet></router-outlet>